<template>
  <tr v-bind:class="{ holiday: isHoliday() }">
    <td>
      {{ formatDateToJapanese(item.c_attendance_date) }}
    </td>
    <td style="text-align: center">
      <!-- <span class="badge badge-daikyu badge-pill fs-md"
                            >代休申請
                          </span> -->
      <span v-html="showRequestStatus()"> </span>
    </td>
    <td>
      <div class="parent">
        <a
          class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2"
          v-if="
            item.c_attendance_lat_work != null &&
            item.c_attendance_lng_work != null
          "
          @click="
            showMap(item.c_attendance_lat_work, item.c_attendance_lng_work)
          "
        >
          <i class="fal fa-map-marker-alt fa-lg"></i>
        </a>
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_time_work"
        />
      </div>
      <!-- <div
        style="display: none"
        :class="{ isUpd: item.c_attendance_flag_upd_work }"
      >
        変更済
      </div> -->
      <span
        class="badge badge-warning badge-pill"
        style="display: none"
        :class="{ isUpd: item.c_attendance_flag_upd_work }"
        >change</span
      >
    </td>
    <td>
      <div class="parent">
        <a
          class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2"
          v-if="
            item.c_attendance_lat_goout_start != null &&
            item.c_attendance_lng_goout_start != null
          "
          @click="
            showMap(
              item.c_attendance_lat_goout_start,
              item.c_attendance_lng_goout_start
            )
          "
        >
          <i class="fal fa-map-marker-alt fa-lg"></i>
        </a>
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_time_goout_start"
        />
        <!-- <div
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_goout_start }"
        >
          変更済
        </div> -->
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_goout_start }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <a
          class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2"
          v-if="
            item.c_attendance_lat_goout_end != null &&
            item.c_attendance_lng_goout_end != null
          "
          @click="
            showMap(
              item.c_attendance_lat_goout_end,
              item.c_attendance_lng_goout_end
            )
          "
        >
          <i class="fal fa-map-marker-alt fa-lg"></i>
        </a>
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_time_goout_end"
        />
        <!-- <div
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_goout_end }"
        >
          変更済
        </div> -->
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_goout_end }"
          >change</span
        >
      </div>
    </td>
    <td class="leaving">
      <div class="parent">
        <a
          class="btn btn-success btn-sm btn-icon rounded-circle waves-effect waves-themed m-2"
          v-if="
            item.c_attendance_lat_leaving != null &&
            item.c_attendance_lng_leaving != null
          "
          @click="
            showMap(
              item.c_attendance_lat_leaving,
              item.c_attendance_lng_leaving
            )
          "
        >
          <i class="fal fa-map-marker-alt fa-lg"></i>
        </a>
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_time_leaving"
        />
        <!-- <div
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_leaving }"
        >
          変更済
        </div> -->
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_leaving }"
          >change</span
        >
      </div>
    </td>
    <!-- ----------------------------- -->
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot1_aftertime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_aftertime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot2_nighttime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_nighttime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot3_hd_aftertime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_hd_aftertime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot4_hd_nighttime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_hd_nighttime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot5_sp_aftertime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_sp_aftertime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <div class="parent">
        <input
          type="time"
          class="time ml-auto"
          :disabled="isDisable"
          v-model="item.c_attendance_ot6_sp_nighttime"
        />
        <span
          class="badge badge-warning badge-pill"
          style="display: none"
          :class="{ isUpd: item.c_attendance_flag_upd_sp_nighttime }"
          >change</span
        >
      </div>
    </td>
    <td>
      <textarea
        class="form-control form-control-sm p-1"
        :disabled="isDisable"
        v-model="item.cnvRemarks"
      ></textarea>
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";

import {
  DtoAttendancesGetResImple,
  attendanceItem,
} from "furukawa-common/src/common/dto/DtoAttendancesGetResImple";
import {
  CONST_OP_OVERTIME_TYPE,
  CONST_OP_HOLIDAY_PART_TYPE,
  CONST_OP_HOLIDAY_TYPE,
} from "furukawa-common/src/common/constant/Constants";

@Options({
  components: {},
})
export default class Mo_tableAttendance_row extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: attendanceItem;
  @Prop({ required: true })
  isDisable: boolean;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------

  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //
  }

  isHoliday(): boolean {
    if (this.item.c_attendance_date == null) {
      return false;
    }
    let dateTmp = new Date(this.item.c_attendance_date);
    const dayOfWeek = dateTmp.getDay();

    if (dayOfWeek >= 1 && dayOfWeek <= 5 && this.item.item4holiday == null) {
      // 月曜から金曜までの処理
      return false;
    } else {
      // 土曜または日曜の処理
      return true;
    }
  }

  showRequestStatus(): string {
    let res = "";
    let txtTmp: string | undefined = "";
    let txtTmpHoliday: string | undefined = "";

    // 残業申請。
    //-------
    for (
      let index = 0;
      index < this.item.item4requestOvertime.length;
      index++
    ) {
      txtTmp = CONST_OP_OVERTIME_TYPE.find(
        (e) =>
          e.code ===
          this.item.item4requestOvertime[index].c_request_overtime_type!
      )?.label;
      if (txtTmp == undefined) {
        txtTmp = "残業申請";
      }

      res +=
        '<a href="/shinsei_Zangyoedit?id=' +
        this.item.item4requestOvertime[index].c_request_id +
        '"><span class="badge badge-info badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestOvertime[index].c_request_id +
        "</span></a><br>";
    }

    // 休暇申請。
    //-------
    for (let index = 0; index < this.item.item4requestHoliday.length; index++) {
      txtTmp = CONST_OP_HOLIDAY_TYPE.find(
        (e) =>
          e.code ===
          this.item.item4requestHoliday[index].c_request_holiday_type!
      )?.label;
      if (txtTmp == undefined) {
        txtTmp = "休暇申請";
      }
      if (
        this.item.item4requestHoliday[index].c_request_holiday_part_type != null
      ) {
        txtTmpHoliday = CONST_OP_HOLIDAY_PART_TYPE.find(
          (e) =>
            e.code ===
            this.item.item4requestHoliday[index].c_request_holiday_part_type!
        )?.label;

        if (txtTmpHoliday != undefined) {
          txtTmp += "<br>" + txtTmpHoliday;
        }
      }

      res +=
        '<a href="/shinsei_Kyukatodokeedit?id=' +
        this.item.item4requestHoliday[index].c_request_id +
        '"><span class="badge badge-success badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestHoliday[index].c_request_id +
        "</span></a><br>";
    }

    //出張申請。
    //-------
    for (let index = 0; index < this.item.item4requestBiztrip.length; index++) {
      txtTmp = "出張";

      res +=
        '<a href="/shinsei_Shutchoedit?id=' +
        this.item.item4requestBiztrip[index].c_request_id +
        '"><span class="badge badge-secondary badge-pill fs-md">' +
        txtTmp +
        " " +
        // this.item.item4requestOvertime[index].c_request_id +
        "</span></a><br>";
    }

    return res;
  }

  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * クリック時のマップ呼び出し処理
   */
  async showMap(lat: string, lng: string) {
    this.$emit("evShowMap", { lat: lat, lng: lng });
  }
  /**
   * 日時のフォーマット変更
   * @param date
   */
  formatDateToJapanese(date: Date | null): string {
    if (date == null) {
      return "";
    }
    let dateTmp = new Date(date);
    const month = ("00" + (dateTmp.getMonth() + 1)).slice(-2);
    const day = ("00" + dateTmp.getDate()).slice(-2);

    const weekdays = ["日", "月", "火", "水", "木", "金", "土"];
    const weekday = weekdays[dateTmp.getDay()];

    return `${month}月${day}日（${weekday}）`;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
td {
  position: relative;
}
input,
textarea {
  border: none;
}
input[disabled],
textarea[disabled] {
  /* background-color: #ffffff; */
  background-color: #ffffff;
}
.parent {
  display: flex;
}
.fa-map-marker-alt {
  color: #ffffff;
}
.isUpd {
  display: block !important;
  /* color: #fff; */
  /* background-color: #f00; */
  font-size: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 1px;
}
.holiday,
.holiday input,
.holiday textarea {
  background-color: #fafafa;
}
.leaving {
  /* border-right: 1px solid #7289aa; */
}
</style>
